<template>
    <div class="container-fluid mr-0 ml-0 mt-4 p-0 g-3 input" :class="{'row align-items-center': !this.labelTop, 'mt-0': this.first, 'd-flex flex-column': this.labelTop}">
        <div 
            class="p-0 mt-0 d-flex align-items-center" 
            :class="{
                'col-sm-12 fsp14 mb8 lh20': this.doublebus || this.is_request || this.labelTop, 
                'col-sm-6': !this.doublebus && !this.is_request && !this.labelTop, 'mb-1': this.is_request
            }"
        >
            <label :for="id" class="pb-0" :class="{ 'primary-grey': !labelTop }">
                {{this.label}}
                <span class='require' v-if="this.require"> *</span>
            </label>
            <Popper v-if="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper>
        </div>
        <div 
            class="p-0 input-wrapper mt-0 d-flex align-items-center gap-2" 
            :class="{
                'col-sm-12': this.doublebus || this.is_request, 
                'col-sm-6': !this.doublebus && !this.is_request && !this.labelTop
            }"
        > 
            <SelectSimple
                :dataValue.sync='this.dataValue' 
                :id='this.id'
                :hotUpdate="this.hotUpdate" 
                :keyt="this.keyt"
                :keywords.sync='this.keywords'
                :invalid='this.invalid && !this.disable'
                :invalidHint="this.invalidHint"
                :disable="this.disable"
                :defaultValue="this.defaultValue"
                :isSearch="this.isSearch"
                :searchType="this.searchType"
                :isFilterSelect="this.isFilterSelect"
                @blurInput="this.blure"  
                @updateParentState="this.setValue"
            />
            <!-- <Tooltip v-if="this.hint" :id="id + '_hint'" :content='this.hint'/> -->
            <!-- <Popper v-if="this.hint" :content="this.hint" :hover="true" :id="id + '_hint'">
                <Icon name="info" size="c16" class="ml4" />
                <template #content>
                    <span>{{ this.hint }}</span>
                </template>
            </Popper> -->
            <div
                v-if="this.doublebus"
                class="mw34"
                style="margin: 0 5px;"
            ></div>
            <!-- <div v-else-if="this.unvisible" class="mw34"></div> -->
            <Popper v-if="this.verification" :hover="true":id="id + '_check'">
                <Icon name="check-mark" :color="{ 0: '#018A5A'}" class="c18" />
                <template #content>
                    <span>{{ $t('views.InfoReg.3') }}</span>
                </template>
            </Popper>
            <!-- <div v-else-if="this.unvisible || this.vMark" class="mw34"></div> -->
            <Popper v-if="this.unvisible" :hover="true" :id="id + '_av'">
                <SwitchSimple
                    :id="id + '_switch_id'"
                    :dataValue='this.unvisibleValue'
                    :disabled="this.is_public == '2' ? true : false"
                    :type="'sm'"
                    class="ml-1"
                    @updateParentState="this.setUnvisibleValue"
                />
                <template #content>
                    <span>{{ $t('views.InfoReg.4') }}</span>
                </template>
            </Popper>
        </div> 
    </div>
</template>

<script>
import SelectSimple from '@/components/service/SelectSimple';
import SwitchSimple from '@/components/service/SwitchSimple';
import Tooltip from '@/components/service/Tooltip';
import Icon from '@/components/icons/Icon';
import Popper from '@/components/service/Popper';

export default {
    components: {
        Tooltip,
        SelectSimple,
        SwitchSimple,
        Icon,
        Popper
    },
    data() {
        return {
            unvisibleValue: this.unvisibleDataValue ? this.unvisibleDataValue : '',
        }
    },
    props: {
        id: [String, Boolean],
        keywords: [Array],
        dataValue: [String, Boolean],
        require: [Boolean],
        hint: [String, Boolean],
        invalidHint: [String],
        invalid: [Boolean],
        label: [String],
        doublebus: [Boolean],
        verification: [String, Boolean],
        keyt: {
            default: false,
            type: [Boolean],
        },
        first: {
            type: Boolean,
            default: false,
        },
        disable: {
            default: false,
            type: [Boolean]
        },
        defaultValue: {
            default: '',
            type: [String],
        },
        isSearch: {
            default: false,
            type: [Boolean]
        },
        unvisible: [Boolean],
        unvisibleDataValue: [String, Boolean], 
        vMark: [Boolean],
        is_public: [Boolean, String],
        is_request: [Boolean],
        searchType: {
            default: 'value',
            type: [String],
            Required: false
        },
        isFilterSelect: {
            default: false,
            type: [Boolean],
        },
        hotUpdate: {
            default: false,
            type: [Boolean],
        },
        labelTop: {
            default: false,
            type: [Boolean],
        }
    },
    methods: {
        setValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id,
                value: arg.value
            })
        },
        blure(arg) {
            this.$emit('blurInput', {
                id: arg.id,
                value: arg.value
            })
        },
        setUnvisibleValue(arg) {
            this.$emit('updateParentState', {
                id: arg.id.replace(/_switch_id/, ''),
                unvisible: true,
                value: arg.value
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.input {
    font-family: 'HelveticaNeue roman';
    &-wrapper {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
    }

}
.require {
    color: red;
}


</style>